import { Button } from 'components/button/Button'
import { ButtonProps } from 'components/button/types'
import {
  ThemedTextImageSection,
  ThemedTextImageSectionProps,
} from 'components/content/themedTextImageSection/ThemedTextImageSection'
import { Icon } from 'components/icon'
import { ContentfulImage } from 'components/Image'
import { Spacer } from 'components/spacer/Spacer'
import { Text } from 'components/Typography'
import { useTranslation } from 'next-i18next'
import { useAuth } from 'utils/auth/hooks/useAuth'
import { useContentfulImages } from 'utils/contentful/ContentfulImagesContext'
import { Namespaces } from 'utils/i18n/types'

interface Props {
  section: Extract<
    keyof Namespaces['cyberscout']['cyberscout'],
    'section_alerts' | 'section_credit_fraud' | 'section_support'
  >
  extraProps?: ThemedTextImageSectionProps
}

export const CyberscoutLPSection = ({ section, extraProps }: Props) => {
  const { t } = useTranslation('cyberscout')
  const images = useContentfulImages()
  const { isLogged } = useAuth()

  const ctaHref = isLogged ? '/me/dashboard?cyberscout=true' : '/signup'

  return (
    <>
      <ThemedTextImageSection
        title={t(`cyberscout.${section}.title`)}
        image={<ContentfulImage {...images[`cyberscout_${section}`]} />}
        {...extraProps}
      >
        <Text>{t(`cyberscout.${section}.description`)}</Text>
        <Button {...defaultButtonProps} href={ctaHref}>
          {t(`cyberscout.${section}.cta`)}
        </Button>
      </ThemedTextImageSection>

      <Spacer size={[2, 6]} />
    </>
  )
}

const defaultButtonProps: ButtonProps = {
  type: 'button',
  variant: 'text',
  size: 'large',
  style: { alignSelf: 'start' },
  tone: 'dark',
  leftIcon: <Icon name="Cyberscout" />,
}
